import React from "react";
import { atom, useAtom } from "jotai";
import { countAtom } from "./atoms";
import Buttons from "./Buttons";
import AvatarBubble from "../components/common/AvatarBubble/AvatarBubble";
import DropDown from "../components/common/DropDown/DropDown";

const Test = () => {
  const [count, setCount] = useAtom(countAtom);

  return (
    <div>
      <AvatarBubble />
      <DropDown />
    </div>
  );
};

export default Test;
